/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useSelector } from 'react-redux';
import { FlexWrapper } from 'Shared/FlexWrapper';
import { globalMessageSelectors } from 'State';
import { GlobalMessage as GlobalMessageType } from 'Types';
import GlobalMessage from './GlobalMessage/GlobalMessage';

export const GlobalMessageWrapper: React.FC = () => {
    const globalMessageList = useSelector(globalMessageSelectors.globalMessageList);

    return (
        <FlexWrapper
            align="center"
            justify="center"
            column
            style={{
                position: 'fixed',
                top: '5rem',
                width: '100%',
                // Modal: z-index: 100
                zIndex: '200',
            }}
        >
            {globalMessageList.map((globalMessage: GlobalMessageType) => (
                <GlobalMessage key={globalMessage.id} globalMessage={globalMessage} />
            ))}
        </FlexWrapper>
    );
};
